module.exports = __webpack_public_path__ + "static/media/vendor-portal.4d66e551.svg";